export enum DIRECTORIES {
    /**
     * @value Directory entries
     */
    CONTENTS = 'ADMIN.NAV.DIRECTORY_CONTENTS',
    /**
     * @value Directories
     */
    DIRECTORIES = 'DIRECTORIES',
    /**
     * @value Modules
     */
    MODULES = 'ADMIN.NAV.MODULES',
    /**
     * @value Select a site to be able to filter by directory
     */
    SELECT_A_SITE_FIRST = 'DIRECTORIES.SELECT_A_SITE_FIRST',
}
